import { DisplayMode } from '@r-core';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const showAllDimensionsMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Show All Dimensions',
		displayModes: [DisplayMode.Overhead, DisplayMode.OverheadManufacturing, DisplayMode.SkuOverhead, DisplayMode.SkuOverheadManufacturing],
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ controller }): void => {
			controller.kitchen.design.dimensions.showAllDimensions();
		}
	};
};
